import createVueComponent from '../createVueComponent';

const CornerDownLeft = createVueComponent('CornerDownLeftIcon', [
  ['polyline', { points: '9 10 4 15 9 20' }],
  ['path', { d: 'M20 4v7a4 4 0 01-4 4H4' }],
]);

export default CornerDownLeft;
